import React from 'react'

import { motion } from 'motion/react'

import { cn } from '@/lib/utils.ts'

export type AnimatedBoxProps = React.HtmlHTMLAttributes<HTMLDivElement>

export const AnimatedBox = React.forwardRef<HTMLDivElement, AnimatedBoxProps>(
  ({ className, children, ...props }, ref) => (
    <div className={cn(className)} ref={ref} {...props}>
      <motion.div
        initial={{ width: 0, display: 'block' }}
        animate={{ width: '100%', transitionEnd: { width: 0, display: 'none' } }}
        transition={{ duration: 0.8 }}
        className="h-0.5 bg-blue-600"
      />

      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto', transition: { delay: 0.8 } }}
        exit={{ opacity: 0, height: 0, transition: { delay: 1.5 } }}>
        <motion.div
          initial={false}
          animate={{ opacity: 1, backgroundColor: 'var(--white)' }}
          exit={{ opacity: 0.7, backgroundColor: 'var(--gray-300)', transition: { delay: 0.1 } }}>
          <motion.div
            initial={false}
            animate={{ width: '100%', display: 'none' }}
            exit={{ width: 0, display: 'block' }}
            transition={{ duration: 1.5 }}
            className="h-0.5 bg-gray-600"
          />
          {children}
        </motion.div>
      </motion.div>
    </div>
  )
)
